import React from 'react';

export default function PractitionerBanner() {
  return (
    <section className="py-16 sm:py-20" data-testid="practitioner-banner">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="bg-[#3A4035] rounded-3xl px-8 py-14 sm:px-12 sm:py-18 lg:px-16 lg:py-20 text-center overflow-hidden">
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-medium text-[#F2F0EB] tracking-tight mb-12 max-w-2xl mx-auto leading-snug">
            Helping practitioners turn their passion into a successful business.
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-10 max-w-lg sm:max-w-2xl mx-auto">
            {[
              { icon: <CommunityIcon />, label: 'Community' },
              { icon: <SupportIcon />, label: 'Support' },
              { icon: <GrowthIcon />, label: 'Growth' },
              { icon: <SuccessIcon />, label: 'Success' },
            ].map(item => (
              <div key={item.label} className="text-center">
                <div className="flex justify-center mb-3">{item.icon}</div>
                <p className="text-xs tracking-[0.15em] uppercase font-medium text-[#F2F0EB]/70">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CommunityIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="#F2F0EB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.8">
      <circle cx="10" cy="9" r="3" /><circle cx="22" cy="9" r="3" /><circle cx="16" cy="19" r="3" />
      <path d="M5 16c0-2 2-3.5 5-4.5" /><path d="M27 16c0-2-2-3.5-5-4.5" />
      <path d="M10 26c0-2 2-3.5 6-4.5" /><path d="M22 26c0-2-2-3.5-6-4.5" />
    </svg>
  );
}

function SupportIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="#F2F0EB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.8">
      <path d="M16 6c0 3-2 5-5 5s-5-2-5-5" /><path d="M16 6c0 3 2 5 5 5s5-2 5-5" />
      <circle cx="16" cy="4.5" r="2" /><path d="M16 6.5v5" />
      <path d="M10 15c-3 1-4.5 3-4.5 5.5v1.5h21v-1.5c0-2.5-1.5-4.5-4.5-5.5" />
      <path d="M13 26v-3" /><path d="M19 26v-3" />
    </svg>
  );
}

function GrowthIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="#F2F0EB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.8">
      <path d="M16 26V12" /><path d="M16 12c0-4 3-6 6-6" /><path d="M16 16c0-3-2.5-5-5-5" />
      <path d="M12 26h8" />
      <circle cx="22" cy="6" r="1.5" /><circle cx="11" cy="11" r="1.5" />
    </svg>
  );
}

function SuccessIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="#F2F0EB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.8">
      <path d="M16 4l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z" />
    </svg>
  );
}
